import React, { FC } from "react";

import { ViewDetailView } from "./ViewDetailView";
import { ViewListView } from "./ViewListView";

/** `/views` — every calendar the user reaches, with this month's figures. */
export const ViewsList: FC = () => <ViewListView />;

/** `/views/:id` */
export const ViewDetails: FC = () => <ViewDetailView />;
